import {css} from "styled-components"

export const mainStyles = css`
  ${({theme}) => `
    font-family: ${theme.font.bold};
    color: ${theme.colors.greys.black};
    letter-spacing: 0;
    font-size: 12px;
    line-height: 18px;
  `}
`
